import axios from "axios";

// ─────────────────────────────────────────────────────────────────────────
// API base URL resolution
//
// The frontend can be served from multiple hostnames:
//   • https://blackrdg.com               (production custom domain)
//   • https://www.blackrdg.com           (production www)
//   • https://*.emergent.host            (production Emergent host)
//   • https://*.preview.emergentagent.com (Emergent preview)
//   • http://localhost:3000              (local dev)
//
// For HttpOnly cookie auth to survive across page navigations, the API MUST
// be called on the SAME origin as the page the user is viewing. A SameSite=Lax
// cookie set under domain A cannot be read or sent by the browser on a
// cross-site fetch from domain B.
//
// Strategy: at runtime, if we're rendered on a hostname that resolves the
// backend at the same origin (the Kubernetes ingress maps /api/* to backend
// on every hostname this app is served from), prefer the empty/same-origin
// base URL. Only fall back to REACT_APP_BACKEND_URL when we are clearly
// running outside a browser (SSR / build time).
// ─────────────────────────────────────────────────────────────────────────
function resolveApiBase() {
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    // Always use same-origin in the browser. This keeps cookies first-party.
    return `${window.location.origin}/api`;
  }
  // Non-browser fallback (build-time, SSR, tests).
  const configured = process.env.REACT_APP_BACKEND_URL || "";
  return `${configured}/api`;
}

export const API_BASE = resolveApiBase();

// Public client — used by lead forms etc.
export const publicClient = axios.create({ baseURL: API_BASE });

// Admin client — uses httpOnly cookies via withCredentials.
// No localStorage tokens are read or written by this client.
export const adminClient = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});
